import { createContext } from "react";

const FromLocalStorageContext = createContext({ loadedLocally: false });

export { FromLocalStorageContext };
